export default {"src":"/_next/static/media/icon_play_tungsten_headtohead.882cd28b.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};